import React from 'react';
import { FaUniversity } from 'react-icons/fa';

const BankTransferDetails = () => {
  return (
    <div className="mt-3 p-3 bg-blue-50 text-blue-800 rounded border border-blue-200 ml-6">
      <div className="flex items-center mb-2">
        <FaUniversity className="mr-2 text-blue-700" size={18} />
        <p className="font-medium">Пратката ще бъде изпратена след получено плащане.</p>
      </div>
      <p className="font-medium mb-1">Данни за превод:</p>
      <p>Име: RALITSA RADIANOVA CHAKAROVA</p>
      <p>Банка: KBC Банк България</p>
      <p>IBAN: BG58RZBB91551014329483</p>
      <p>BIC/SWIFT: RZBBBGSF</p>
    </div>
  );
};

export default BankTransferDetails; 